export const USER_LOGIN = "USER_LOGIN"
export const REGISTER_USER = "REGISTER_USER"
export const CAPTCHA_ACTION_REGISTER = "register"